module.exports = __webpack_public_path__ + "img/Fa.cc843333.png";